import type { CSSProperties } from 'react';

interface RawProps {
  html: string;
  className?: string;
  style?: CSSProperties;
}

/** Renders developer-authored SVG markup from art.ts (never user input). */
export default function Raw({ html, className, style }: RawProps) {
  return <div className={className} style={style} dangerouslySetInnerHTML={{ __html: html }} />;
}
